module.exports = __webpack_public_path__ + "static/media/on_the_table.93067b8d.png";